import _styled from "styled-components";
import { useMemo } from 'react';
import { Timeline as FlowBiteTimeLine } from 'flowbite-react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { getAssetSrc } from '@restworld/utils-common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Item = FlowBiteTimeLine.Item,
    Content = FlowBiteTimeLine.Content,
    Title = FlowBiteTimeLine.Title,
    Body = FlowBiteTimeLine.Body;
export var Timeline = function Timeline(_ref) {
  var timeLineSteps = _ref.timeLineSteps;
  var items = useMemo(function () {
    return timeLineSteps.map(function (_ref2, i, list) {
      var key = _ref2.key,
          title = _ref2.title,
          subtitle = _ref2.subtitle,
          checked = _ref2.checked,
          isFlagged = _ref2.isFlagged;
      var icon = checked ? /*#__PURE__*/_jsx(CheckIcon, {
        strokeWidth: 3,
        className: "h-3 w-3 text-primary-300 text-bold"
      }) : isFlagged ? /*#__PURE__*/_jsx("img", {
        src: getAssetSrc('/utils-assets/flag-checkmark.svg'),
        alt: ""
      }) : key;
      var verticalLine = list.length - 1 !== i ? /*#__PURE__*/_jsx(VerticalLineStyled, {}) : null;
      return /*#__PURE__*/_jsxs(ItemStyled, {
        twstyle: list.length - 1 === i ? {
          "marginBottom": "0px"
        } : {},
        children: [/*#__PURE__*/_jsxs(TimeLineIconWrapper, {
          children: [/*#__PURE__*/_jsx(TimeLineIcon, {
            children: icon
          }), verticalLine]
        }), /*#__PURE__*/_jsxs(Content, {
          children: [/*#__PURE__*/_jsx(TitleStyled, {
            children: title
          }), subtitle ? /*#__PURE__*/_jsx(BodyStyled, {
            children: subtitle
          }) : null]
        })]
      }, title);
    });
  }, [timeLineSteps]);
  return /*#__PURE__*/_jsx(FlowBiteTimeLineStyled, {
    children: items
  });
};
export default Timeline; // --> parent > styled components

var FlowBiteTimeLineStyled = /*#__PURE__*/_styled(FlowBiteTimeLine).withConfig({
  displayName: "timeline__FlowBiteTimeLineStyled",
  componentId: "sc-jasq0c-0"
})({
  "marginLeft": "0.75rem",
  "borderStyle": "none",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))"
});

var VerticalLineStyled = /*#__PURE__*/_styled.span.withConfig({
  displayName: "timeline__VerticalLineStyled",
  componentId: "sc-jasq0c-1"
})(["", ""], {
  "position": "absolute",
  "left": "0.75rem",
  "top": "2rem",
  "height": "3.5rem",
  "borderWidth": "1.5px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(105 62 181 / var(--tw-border-opacity))"
});

var ItemStyled = /*#__PURE__*/_styled(Item).withConfig({
  displayName: "timeline__ItemStyled",
  componentId: "sc-jasq0c-2"
})(["", " ", ""], {
  "marginBottom": "1.5rem"
}, function (_ref3) {
  var twstyle = _ref3.twstyle;
  return twstyle;
});

var TitleStyled = /*#__PURE__*/_styled(Title).withConfig({
  displayName: "timeline__TitleStyled",
  componentId: "sc-jasq0c-3"
})({
  "fontSize": "1rem",
  "lineHeight": "1.5rem"
});

var BodyStyled = /*#__PURE__*/_styled(Body).withConfig({
  displayName: "timeline__BodyStyled",
  componentId: "sc-jasq0c-4"
})({
  "--tw-text-opacity": "1",
  "color": "rgb(75 85 99 / var(--tw-text-opacity))"
});

var TimeLineIconWrapper = /*#__PURE__*/_styled.span.withConfig({
  displayName: "timeline__TimeLineIconWrapper",
  componentId: "sc-jasq0c-5"
})({
  "position": "absolute",
  "left": "-0.75rem",
  "display": "flex",
  "height": "1.5rem",
  "width": "1.5rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderRadius": "9999px",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))",
  "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
  "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(8px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
  "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)",
  "--tw-ring-opacity": "1",
  "--tw-ring-color": "rgb(255 255 255 / var(--tw-ring-opacity))",
  ".dark &": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(35 56 118 / var(--tw-bg-opacity))",
    "--tw-ring-opacity": "1",
    "--tw-ring-color": "rgb(17 24 39 / var(--tw-ring-opacity))"
  }
});

var TimeLineIcon = /*#__PURE__*/_styled.span.withConfig({
  displayName: "timeline__TimeLineIcon",
  componentId: "sc-jasq0c-6"
})({
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "--tw-text-opacity": "1",
  "color": "rgb(105 62 181 / var(--tw-text-opacity))"
});

export * from './timeline.mocks';